import { render, staticRenderFns } from "./formPageContact.vue?vue&type=template&id=22e63d1a&scoped=true"
import script from "./formPageContact.vue?vue&type=script&lang=js"
export * from "./formPageContact.vue?vue&type=script&lang=js"
import style0 from "./formPageContact.vue?vue&type=style&index=0&id=22e63d1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e63d1a",
  null
  
)

export default component.exports